<template>
	<div class="page">
		<!-- 筛选 -->
		<div class="filter">
			<el-input placeholder="请输入内容" v-model="keyword" clearable prefix-icon="el-icon-search" class="sousuo"
				size="small">
			</el-input>
			<el-button type="warning" @click="getTableData" size="small">搜索</el-button>
			<div class="filterName" v-if="shopType == 0">门店筛选：</div>
			<el-select v-model="shopIds" placeholder="请选择" class="titleSelect" style="width: 100px;"
				size="small" @change="getTableData" v-if="shopType == 0">
				<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<div class="filterName">转移门店：</div>
			<el-select v-model="shopId" placeholder="请选择" class="titleSelect" style="width: 100px;margin-right: 4px;"
				size="small">
				<el-option v-for="item in shops" :key="item.value" :label="item.label" :value="item.value" />
			</el-select>
			<el-button type="warning" @click="handelTransClick" size="small">转移</el-button>
			<div style="flex: 1;text-align: right;">
				<el-button type="warning" plain size="small" style="margin-right: 20px;" @click="handelFilterClick">筛选</el-button>
			</div>
		</div>
		<div class="view">
			<div class="item" v-for="(item,index) in tableData" :key="index" @click="item.isClick = !item.isClick"
				:style="{'background': item.isClick?'rgba(0, 0, 0, 0.29)':'#fff'}">
				<div class="itemL">
					<div class="itemName">{{item.petName}}</div>
					<div class="itemMsg">
						<div>{{item.categoryInfo.name}}</div>
						<div class="shu"></div>
						<div>{{item.petSex}}</div>
						<div class="shu"></div>
						<div>{{item.age}}</div>
					</div>
					<div class="epromNo">芯片:{{item.epromNo}}</div>
					<div class="insideNo">脖圈:{{item.insideNo}}</div>
				</div>
				<el-image class="itemR" :src="item.cover" fit="fill"></el-image>
				<img src="../../../assets/img/ht_dui.png" class="dui" v-if="item.isClick">
			</div>
		</div>
		<el-drawer title='筛选' :modal='false' size='40%' :visible.sync="filterDrawer" custom-class='drawersend'
			direction="rtl">
			<div class="sx">
				<div class="sxMsg">
					<div class="line"></div>
					<div class="comWrap">
						<div class="comView">
							<div class="comName">宠物类型:</div>
							<div class="comTab">
								<div @click="tab = 0" :style="{'color':tab == 0?'#F5882A':''}">全部</div>
								<div @click="tab = 1" :style="{'color':tab == 1?'#F5882A':''}">猫</div>
								<div @click="tab = 2" :style="{'color':tab == 2?'#F5882A':''}">狗</div>
							</div>
						</div>
						<div class="comView" v-if="tab == 0 || tab == 1">
							<div class="comName">猫:</div>
							<div class="comTab">
								<div :style="{'color':allCat?'#F5882A':''}" @click="handelAllCatClick">全部</div>
								<div v-for="(item,index) in catData" :key="index" @click="handelCatClick(item)" :style="{'color':item.isClick?'#F5882A':''}">{{item.label}}</div>
							</div>
						</div>
						<div class="comView" v-if="tab == 0 || tab == 2">
							<div class="comName">犬:</div>
							<div class="comTab">
								<div :style="{'color':allDog?'#F5882A':''}" @click="handelAllDogClick">全部</div>
								<div v-for="(item,index) in dogData" :key="index" @click="handelDogClick(item)" :style="{'color':item.isClick?'#F5882A':''}">{{item.label}}</div>
							</div>
						</div>
						<div class="comView">
							<div class="comName">性别:</div>
							<div class="comTab">
								<div v-for="(item,index) in sexs" :key="index" @click="handelSexClick(item,index)" :style="{'color':index == sexIndex?'#F5882A':''}">{{item.label}}</div>
							</div>
						</div>
						<div class="comView">
							<div class="comName">疫苗针数:</div>
							<div class="comTab">
								<div v-for="(item,index) in vaccines" :key="index" @click="handelVaccineClick(item,index)" :style="{'color':index == vaccineIndex?'#F5882A':''}">{{item.label}}</div>
							</div>
						</div>
						<div class="comView">
							<div class="comName">年龄:</div>
							<div class="comTab">
								<div v-for="(item,index) in ages" :key="index" @click="handelAgeClick(item,index)" :style="{'color':index == ageIndex?'#F5882A':''}">{{item.label}}</div>
							</div>
						</div>
					</div>
				</div>
				<div class="sxBtn">
					<div @click="resetClick">重置</div>
					<div @click="handelCertainClick">确定</div>
				</div>
			</div>
		</el-drawer>
	</div>
</template>

<script>
	import {
		transferList,
		breedTree,
		petTransfer
	} from "@/api/purchaseApi.js"
	export default {
		props: {
			shopType: {
				type: Number,
				default: 0
			},
		},
		data() {
			return {
				tableData: [],
				shops: [{
					value: '5e9412e0b2bfbc089daerr12',
					label: '金水区店'
				}, {
					value: '5e9412e0b2bfbc089daerr14',
					label: '指挥中心'
				}, {
					value: '5e9412e0b2bfbc089daerr18',
					label: '郑东新区店'
				}, {
					value: '5e9412e0b2bfbc089daerr10',
					label: '驯养中心'
				}],
				shopId: '', //转移门店id
				keyword: '', //列表搜索内容
				filterDrawer:false,  //筛选弹框
				dogData:[],  //狗数据
				catData:[],  //猫数据
				tab:0,
				allCat:true,
				allDog:true,
				categoryId:'',
				shopIds: '', //门店id
				minPrice: '',
				maxPrice: '',
				sex: '',
				sexIndex:0,
				sexs:[{
					value:'',
					label:'全部'
				},{
					value:'公',
					label:'公'
				},{
					value:'母',
					label:'母'
				}],
				vaccineCount: '',
				vaccineIndex:0,
				vaccines:[{
					value:'',
					label:'全部'
				},{
					value:'0',
					label:'第0针'
				},{
					value:'1',
					label:'第1针'
				},{
					value:'2',
					label:'第2针'
				},{
					value:'3',
					label:'第3针'
				},{
					value:'4',
					label:'第4针'
				}],
				age: '',
				ageIndex: 0,
				ages:[{
					value:'',
					label:'全部'
				},{
					value:'1',
					label:'0-3个月'
				},{
					value:'2',
					label:'3-6个月'
				},{
					value:'3',
					label:'6-9个月'
				},{
					value:'4',
					label:'9-12个月'
				},{
					value:'5',
					label:'1年以上'
				}],
			}
		},
		mounted() {
			this.getBreedData()
			this.getTableData()
			this.getBreedData()
		},
		methods: {
			//选择年龄
			handelAgeClick(item,index){
				this.ageIndex = index;
				this.age = item.value;
			},
			//选择疫苗
			handelVaccineClick(item,index){
				this.vaccineIndex = index;
				this.vaccineCount = item.value;
			},
			//选择性别
			handelSexClick(item,index){
				this.sexIndex = index;
				this.sex = item.value;
			},
			//筛选
			handelFilterClick(){
				this.filterDrawer = true;
			},
			//弹框确认
			handelCertainClick(){
				if(this.tab == 0){  //全部
					if(this.allCat && this.allDog){
						this.categoryId = ''
					}
					if(!this.allCat && this.allDog){
						let catStr = '';
						for(let i = 0;i<this.catData.length;i++){
							if(this.catData[i].isClick){
								catStr = catStr+this.catData[i].id+','
							}
						}
						this.categoryId = catStr
					}
					if(this.allCat && !this.allDog){
						let dogStr = '';
						for(let i = 0;i<this.dogData.length;i++){
							if(this.dogData[i].isClick){
								dogStr = dogStr+this.dogData[i].id+','
							}
						}
						this.categoryId = dogStr
					}
					if(!this.allCat && !this.allDog){
						let catStr = '';
						for(let i = 0;i<this.catData.length;i++){
							if(this.catData[i].isClick){
								catStr = catStr+this.catData[i].id+','
							}
						}
						let dogStr = '';
						for(let j = 0;j<this.dogData.length;j++){
							if(this.dogData[j].isClick){
								dogStr = dogStr+this.dogData[j].id+','
							}
						}
						this.categoryId = dogStr+catStr
					}
				}else if(this.tab == 1){  //猫
					let catStr = '';
					if(this.allCat){
						for(let i = 0;i<this.catData.length;i++){
							catStr = catStr+this.catData[i].id+','
						}
					}else{
						for(let i = 0;i<this.catData.length;i++){
							if(this.catData[i].isClick){
								catStr = catStr+this.catData[i].id+','
							}
						}
					}
					this.categoryId = catStr
				}else if(this.tab == 2){  //狗
					let dogStr = '';
					if(this.allDog){
						for(let i = 0;i<this.dogData.length;i++){
							dogStr = dogStr+this.dogData[i].id+','
						}
					}else{
						for(let i = 0;i<this.dogData.length;i++){
							if(this.dogData[i].isClick){
								dogStr = dogStr+this.dogData[i].id+','
							}
						}
					}
					this.categoryId = dogStr
				}
				console.log(this.categoryId)
				this.filterDrawer = false;
				this.getTableData()
			},
			//弹框重置
			resetClick(){
				this.tab = 0;
				this.allCat = true;
				this.allDog = true;
				for(let i = 0;i<this.catData.length;i++){
					this.catData[i].isClick = false
				}
				for(let j = 0;j<this.dogData.length;j++){
					this.dogData[j].isClick = false
				}
				this.keyword = '';
				if(this.shopType == 0){
					this.shopIds = '';
				}
				this.sex = '';
				this.sexIndex = 0;
				this.vaccineCount = '';
				this.vaccineIndex = 0;
				this.age = '';
				this.ageIndex = 0;
				this.handelCertainClick()
			},
			//全部猫
			handelAllCatClick(){
				this.allCat = true;
				for(let i = 0;i<this.catData.length;i++){
					this.catData[i].isClick = false
				}
			},
			//全部狗
			handelAllDogClick(){
				this.allCat = true;
				for(let i = 0;i<this.dogData.length;i++){
					this.dogData[i].isClick = false
				}
			},
			//选择狗品种
			handelDogClick(item){
				console.log(item)
				item.isClick = !item.isClick;
				let num = 0;
				for(let i = 0;i<this.dogData.length;i++){
					if(this.dogData[i].isClick){
						num++
						this.allDog = false;
					}
				}
				console.log(num)
				if(num == 0){
					this.allDog = true;
				}
			},
			//选择猫品种
			handelCatClick(item){
				console.log(item)
				item.isClick = !item.isClick;
				let num = 0;
				for(let i = 0;i<this.catData.length;i++){
					if(this.catData[i].isClick){
						num++
						this.allCat = false;
					}
				}
				console.log(num)
				if(num == 0){
					this.allCat = true;
				}
			},
			//获取品种
			getBreedData() {
				let that = this;
				let params = {
					category: '活体'
				}
				breedTree(params).then((res) => {
					if (res.code == 0) {
						// console.log('品种', res)
						let catData = res.data[0].children[0].children;
						let dogData = res.data[0].children[1].children;
						for(let i = 0;i<catData.length;i++){
							catData[i].isClick = false
						}
						for(let j = 0;j<dogData.length;j++){
							dogData[j].isClick = false
						}
						that.catData = catData;
						that.dogData = dogData;
					}
				})
			},
			formatChu(a) {
				if (a < 12) {
					return a + '个月'
				}
				if (a == 12) {
					return '1岁'
				} else {
					var n1 = Math.floor(a / 12);
					var n2 = a % 12;
					// console.log(a, n1, n2)
					return n1 + '岁' + n2 + '个月'
				}
			},
			//转移按钮
			handelTransClick() {
				let that = this;
				if (this.shopId == '') {
					this.$message({
						type: 'error',
						message: '请选择转移门店'
					});
					return
				}
				this.$confirm('是否转移宠物？', '提示', {
					confirmButtonText: '确定',
					cancelButtonText: '取消',
					type: 'warning'
				}).then(() => {
					let lstPetId = [];
					for (let i = 0; i < this.tableData.length; i++) {
						if (this.tableData[i].isClick) {
							lstPetId.push(this.tableData[i].petId)
						}
					}
					if (lstPetId.length == 0) {
						this.$message({
							type: 'error',
							message: '请选择宠物'
						});
						return
					}
					let params = {
						receiveShopId: this.shopId,
						lstPetId: lstPetId,
						tranferShopId: this.$store.state.shopId
					}
					petTransfer(params).then((res) => {
						if (res.code == 0) {
							console.log('转移成功')
							that.$message({
								type: 'success',
								message: '已转移'
							});
							that.getTableData()
							this.$emit("refresh");
						}
					})
				}).catch(() => {
					this.$message({
						type: 'info',
						message: '已取消删除'
					});
				});
			},
			//获取数据
			getTableData() {
				let that = this;
				let params = {
					keyword: this.keyword,
					categoryId: this.categoryId,
					sex: this.sex,
					vaccineCount:this.vaccineCount,
					age:this.age
				}
				if (this.shopType == 0) {
					params.shopId = this.shopIds
				} else {
					params.shopId = this.$store.state.shopId
				}
				transferList(params).then((res) => {
					if (res.code == 0) {
						console.log('转移列表', res)
						for (let i = 0; i < res.data.data.length; i++) {
							res.data.data[i].isClick = false;
						}
						that.tableData = res.data.data
					}
				})
			},
		},
	}
</script>

<style lang="scss" scoped>
	.page {
		min-height: 762px;
		margin-top: 12px;
		font-size: 14px;
		display: flex;
		flex-direction: column;

		.filter {
			height: 58px;
			display: flex;
			align-items: center;
			background: #fff;

			.sousuo {
				width: 153px;
				margin-right: 4px;
				margin-left: 16px;
			}

			.filterName {
				margin-left: 10px;
				margin-right: 4px;
			}
		}

		.view {
			height: 694px;
			margin-top: 10px;
			overflow-y: scroll;

			.item {
				width: 301px;
				height: 100px;
				border-radius: 4px;
				display: flex;
				padding: 10px;
				font-size: 12px;
				color: #666;
				line-height: 17px;
				margin-bottom: 12px;
				float: left;
				margin-right: 12px;
				position: relative;

				.itemL {
					flex: 1;

					.itemName {
						margin-top: 4px;
						color: #333;
						margin-bottom: 8px;
					}

					.itemMsg {
						display: flex;
						align-items: center;
						margin-bottom: 8px;

						.shu {
							width: 1px;
							height: 14px;
							background: #666;
							margin: 0 8px;
						}
					}

					.epromNo {
						margin-bottom: 8px;
					}
				}

				.itemR {
					width: 150px;
					height: 100px;
					margin-left: 10px;
				}

				.dui {
					width: 24px;
					height: 24px;
					position: absolute;
					right: 8px;
					top: 8px;
					z-index: 3;
				}
			}
		}

		.view::-webkit-scrollbar {
			display: none;
		}
		.line{
			width: 100%;
			height: 1px;
			background: #F2F2F2;
		}
		.sx{
			height: 100%;
			display: flex;
			flex-direction: column;
			justify-content: space-between;
			.comWrap{
				padding: 20px;
				font-size: 12px;
				color: #666;
				line-height: 20px;
				.comView{
					display: flex;
					margin-bottom: 16px;
					.comName{
						width: 52px;
						text-align: right;
					}
					.comTab{
						flex: 1;
						display: flex;
						flex-wrap: wrap;
						div{
							padding: 0 12px;
							border-right: 1px solid #F2F2F2;
							margin-bottom: 12px;
						}
						div:nth-of-type(1){
							padding-left: 4px;
						}
					}
				}
			}
			.sxBtn{
				height: 40px;
				display: flex;
				cursor: pointer;
				font-size: 14px;
				color: #fff;
				line-height: 40px;
				text-align: center;
				div:nth-of-type(1){
					flex: 1;
					background: #E1E9FB;
					color: #467EFF;
				}
				div:nth-of-type(2){
					flex: 1;
					background: #F5882A;
				}
			}
		}
	}
</style>
